export const stripHtmlTags = (text: string): string => {
    const regex = /<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g;
    return text.replace(regex, '');
};
